import { SALE_ADD, SALE_VIEW, SALE_RETURN_VIEW } from '@/utils/permissions'

export default [
  {
    path: '/pos/invoice-list',
    name: 'pos-invoice-list',
    component: () => import('@/views/pos/InvoiceList.vue'),
    meta: {
      allowAnonymous: false,
      pageTitle: 'Invoice List',
      breadcrumb: [
        { title: 'Dashboard', url: '/dashboard' },
        { title: 'Invoice List', active: true }
      ],
      permissions: [SALE_VIEW]
    }
  },
  {
    path: '/pos/:id/view-sales-invoice',
    name: 'view-invoice',
    component: () => import('@/views/pos/SalesInvoice.vue'),
    meta: {
      allowAnonymous: false,
      pageTitle: 'Sales Invoice List',
      breadcrumb: [
        { title: 'Dashboard', url: '/dashboard' },
        { title: 'Invoice List', url: '/pos/invoice-list' },
        { title: 'Sales Invoice View', active: true }
      ],
      permissions: [SALE_VIEW]
    }
  },
  {
    path: '/pos/edit/sales-return/:id',
    name: 'sales-return-invoice',
    component: () => import('@/views/pos/EditSalesInvoice.vue'),
    meta: {
      allowAnonymous: false,
      pageTitle: 'Sales Return',
      breadcrumb: [
        { title: 'Dashboard', url: '/dashboard' },
        { title: 'Invoice List', url: '/pos/invoice-list' },
        { title: 'Edit Return Sales Entry ', active: true }
      ],
      permissions: [SALE_RETURN_VIEW]
    }
  }
]

export const blankRoutes = [
  {
    path: '/pos/:saleId/invoice',
    name: 'sale-invoice-print',
    component: () => import('@/views/pos/PrintInvoice.vue'),
    meta: {
      allowAnonymous: false,
      pageTitle: 'Test',
      permissions: [SALE_VIEW]
    }
  },
  {
    path: '/pos/:productIds/:saleId/:number',
    name: 'pos-exit-print',
    component: () => import('@/views/pos/ExitLabel.vue'),
    meta: {
      allowAnonymous: false,
      pageTitle: 'Exit Print',
      permissions: [SALE_VIEW]
    }
  }
]

export const posRoutes = [
  {
    path: '/pos',
    name: 'pos',
    component: () => import('@/views/pos/Pos.vue'),
    meta: {
      allowAnonymous: false,
      pageTitle: 'POS',
      breadcrumb: [
        { title: 'Dashboard', url: '/dashboard' },
        { title: 'POS', active: true }
      ],
      permissions: [SALE_ADD]
    }
  },
  {
    path: '/pos/hold-invoice/:id',
    name: 'update_hold_invoice',
    component: () => import('@/views/pos/components/HoldInvoice/UpdateHoldInvoice.vue'),
    meta: {
      allowAnonymous: false,
      pageTitle: 'POS',
      breadcrumb: [
        { title: 'Dashboard', url: '/dashboard' },
        { title: 'POS', active: true }
      ],
      permissions: [SALE_ADD]
    }
  }
]
